import {IoClose} from 'react-icons/io5';
import { Container, SaveButton } from './estilo';
import { useForm } from 'react-hook-form';
import { useEffect } from 'react';
import { toast } from 'react-toastify';
import { useAuth } from '../../../contexts/auth';

export default function CampanhaProdutoPrecos({ fechar, getProdutoPrecos, atualizarProdutoPrecos }){
    const { register, getValues, handleSubmit, reset } = useForm();
    const { signOut, user } = useAuth();

    const carregarPrecos = async () => {
        try {
            const resposta = await getProdutoPrecos()
            const produto = resposta.data.produto

            let precos = {
                id: produto.id,
                nome: produto.nome
            }

            for (const key of Object.keys(produto)) {
                if (key.startsWith('preco') && typeof produto[key] === 'number') {
                    precos[key] = produto[key].toFixed(2)
                }
            }

            reset(precos)
        } catch (error) {
            if(error.response.status === 401) signOut();

            toast.error(error.response.data.error || 'Erro ao carregar preços')
        }
    }

    const atualizarPrecos = async (data) => {
        try {
            data.usuario_id = user.id_usuario

            await atualizarProdutoPrecos(data)

            toast.success('Preços atualizados com sucesso')
        } catch (error) {
            if(error.response.status === 401) signOut();

            toast.error(error.response.data?.error || 'Erro ao atualizar preços')
        }
    }

    useEffect(() => {
        carregarPrecos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return(
        <div className='modalPrecificador'>
            <article
                className='modalPrecificador-container'
            >
                <Container>
                    <div className='modalPrecificador-fechar'>
                        <button
                            onClick={fechar}
                            className='modalPrecificador-btn-fechar'
                            type='button'
                        >
                            <IoClose size={30} color='#FFF'/>
                        </button>
                    </div>
                    <h2>LOJAS FISICAS</h2>

                    <div className='flex'>
                        <div>
                            <article className='lista_precos'>
                                <article className='preco'>
                                    <label className='titulo'>Preco Regular SP</label>
                                    <input
                                        type='number'
                                        step={0.01}
                                        pattern="^\d*(\.\d{0,2})?$"
                                        {...register('preco_regular_SP')}
                                        />
                                    {getValues('preco_regular_SP') > 0 && <label className='legenda'>Valor atual: {getValues('preco_regular_SP')}</label>}
                                </article>
                                <article className='preco'>
                                    <label className='titulo'>Preco Regular SP1</label>
                                    <input
                                        type='number'
                                        step={0.01}
                                        pattern="^\d*(\.\d{0,2})?$"
                                        {...register('preco_regular_SP1')}
                                        />
                                    {getValues('preco_regular_SP1') > 0 && <label className='legenda'>Valor atual: {getValues('preco_regular_SP1')}</label>}
                                </article>

                                <article className='preco'>
                                    <label className='titulo'>Preco Regular SP2</label>
                                    <input
                                        type='number'
                                        step={0.01}
                                        pattern="^\d*(\.\d{0,2})?$"
                                        {...register('preco_regular_SP2')}
                                        />
                                {getValues('preco_regular_SP2') > 0 && <label className='legenda'>Valor atual: {getValues('preco_regular_SP2')}</label>}
                                </article>
                                <article className='preco'>
                                    <label className='titulo'>Preco Regular DF</label>
                                    <input
                                        type='number'
                                        step={0.01}
                                        pattern="^\d*(\.\d{0,2})?$"
                                        {...register('preco_regular_DF')}
                                        />
                                    {getValues('preco_regular_DF') > 0 && <label className='legenda'>Valor atual: {getValues('preco_regular_DF')}</label>}
                                </article>
                                <article className='preco'>
                                    <label className='titulo'>Preco Regular DF1</label>
                                    <input
                                        type='number'
                                        step={0.01}
                                        pattern="^\d*(\.\d{0,2})?$"
                                        {...register('preco_regular_DF1')}
                                        />
                                    {getValues('preco_regular_DF1') > 0 && <label className='legenda'>Valor atual: {getValues('preco_regular_DF1')}</label>}
                                </article>


                                <article className='preco'>
                                    <label className='titulo'>Preco regular GO</label>
                                    <input
                                        type='number'
                                        step={0.01}
                                        pattern="^\d*(\.\d{0,2})?$"
                                        {...register('preco_regular_GO')}
                                        />
                                    {getValues('preco_regular_GO') > 0 && <label className='legenda'>Valor atual: {getValues('preco_regular_GO')}</label>}
                                </article>

                                <article className='preco'>
                                    <label className='titulo'>Preco Regular RJ</label>
                                    <input
                                        type='number'
                                        step={0.01}
                                        pattern="^\d*(\.\d{0,2})?$"
                                        {...register('preco_regular_RJ')}
                                        />
                                    {getValues('preco_regular_RJ') > 0 && <label className='legenda'>Valor atual: {getValues('preco_regular_RJ')}</label>}
                                </article>
                                <article className='preco'>
                                    <label className='titulo'>Preco Regular RJ1</label>
                                    <input
                                        type='number'
                                        step={0.01}
                                        pattern="^\d*(\.\d{0,2})?$"
                                        {...register('preco_regular_RJ1')}
                                        />
                                    {getValues('preco_regular_RJ1') > 0 && <label className='legenda'>Valor atual: {getValues('preco_regular_RJ1')}</label>}
                                </article>
                                <article className='preco'>
                                    <label className='titulo'>Preco Regular X Super</label>
                                    <input
                                        type='number'
                                        step={0.01}
                                        pattern="^\d*(\.\d{0,2})?$"
                                        {...register('preco_regular_x_super')}
                                        />
                                    {getValues('preco_regular_x_super') > 0 && <label className='legenda'>Valor atual: {getValues('preco_regular_x_super')}</label>}
                                </article>
                            </article>
                        </div>
                        <div>
                        <article className='lista_precos'>
                                <article className='preco'>
                                    <label className='titulo'>PRECO SP</label>
                                    <input
                                        type='number'
                                        step={0.01}
                                        pattern="^\d*(\.\d{0,2})?$"
                                        {...register('precoSP')}
                                        />
                                    {getValues('precoSPCadastrado') > 0 && <label className='legenda'>Valor atual: {getValues('precoSPCadastrado')}</label>}
                                </article>
                                <article className='preco'>
                                    <label className='titulo'>PRECO SP1</label>
                                    <input
                                        type='number'
                                        step={0.01}
                                        pattern="^\d*(\.\d{0,2})?$"
                                        {...register('precoSP1')}
                                        />
                                    {getValues('precoSP1Cadastrado') > 0 && <label className='legenda'>Valor atual: {getValues('precoSP1adastrado')}</label>}
                                </article>
                                <article className='preco'>
                                    <label className='titulo'>PRECO SP2</label>
                                    <input
                                        type='number'
                                        step={0.01}
                                        pattern="^\d*(\.\d{0,2})?$"
                                        {...register('precoSP2')}
                                        />
                                    {getValues('precoSP2Cadastrado') > 0 && <label className='legenda'>Valor atual: {getValues('precoSP2Cadastrado')}</label>}
                                </article>

                                <article className='preco'>
                                    <label className='titulo'>PRECO DF</label>
                                    <input
                                        type='number'
                                        step={0.01}
                                        pattern="^\d*(\.\d{0,2})?$"
                                        {...register('precoDF')}
                                        />
                                    {getValues('precoDFCadastrado') > 0 && <label className='legenda'>Valor atual: {getValues('precoDFCadastrado')}</label>}
                                </article>
                                <article className='preco'>
                                    <label className='titulo'>PRECO DF1</label>
                                    <input
                                        type='number'
                                        step={0.01}
                                        pattern="^\d*(\.\d{0,2})?$"
                                        {...register('precoDF1')}
                                        />
                                    {getValues('precoDF1Cadastrado') > 0 && <label className='legenda'>Valor atual: {getValues('precoDF1Cadastrado')}</label>}
                                </article>

                                <article className='preco'>
                                    <label className='titulo'>PRECO GO</label>
                                    <input
                                        type='number'
                                        step={0.01}
                                        pattern="^\d*(\.\d{0,2})?$"
                                        {...register('precoGO')}
                                        />
                                    {getValues('precoGOCadastrado') > 0 && <label className='legenda'>Valor atual: {getValues('precoGOCadastrado')}</label>}
                                </article>

                                <article className='preco'>
                                    <label className='titulo'>PRECO RJ</label>
                                    <input
                                        type='number'
                                        step={0.01}
                                        pattern="^\d*(\.\d{0,2})?$"
                                        {...register('precoRJ')}
                                        />
                                    {getValues('precoRJCadastrado') > 0 && <label className='legenda'>Valor atual: {getValues('precoRJCadastrado')}</label>}
                                </article>
                                <article className='preco'>
                                    <label className='titulo'>PRECO RJ1</label>
                                    <input
                                        type='number'
                                        step={0.01}
                                        pattern="^\d*(\.\d{0,2})?$"
                                        {...register('precoRJ1')}
                                        />
                                    {getValues('precoRJ1Cadastrado') > 0 && <label className='legenda'>Valor atual: {getValues('precoRJ1Cadastrado')}</label>}
                                </article>
                                <article className='preco'>
                                    <label className='titulo'>PRECO X SUPER</label>
                                    <input
                                        type='number'
                                        step={0.01}
                                        pattern="^\d*(\.\d{0,2})?$"
                                        {...register('preco_x_super')}
                                        />
                                    {getValues('preco_x_super') > 0 && <label className='legenda'>Valor atual: {getValues('preco_x_super')}</label>}
                                </article>
                            </article>
                        </div>
                        <div>
                            <article className='lista_precos'>
                                <article className='preco'>
                                    <label className='titulo'>PRECO SP 1 uni.</label>
                                    <input
                                        type='number'
                                        step={0.01}
                                        pattern="^\d*(\.\d{0,2})?$"
                                        {...register('precoSP_faixa_de_preco1')}
                                        />
                                    {getValues('precoSP_faixa_de_preco1') > 0 && <label className='legenda'>Valor atual: {getValues('precoSP_faixa_de_preco1')}</label>}
                                </article>
                                  <article className='preco'>
                                    <label className='titulo'>PRECO SP1 1 uni.</label>
                                    <input
                                        type='number'
                                        step={0.01}
                                        pattern="^\d*(\.\d{0,2})?$"
                                        {...register('precoSP1_faixa_de_preco1')}  
                                        />
                                    {getValues('precoSP1_faixa_de_preco1') > 0 && <label className='legenda'>Valor atual: {getValues('precoSP1_faixa_de_preco1')}</label>}
                                  </article>
                                  <article className='preco'>
                                    <label className='titulo'>PRECO SP2 1 uni.</label>
                                    <input
                                        type='number'
                                        step={0.01}
                                        pattern="^\d*(\.\d{0,2})?$"
                                        {...register('precoSP2_faixa_de_preco1')}
                                        />
                                    {getValues('precoSP2_faixa_de_preco1') > 0 && <label className='legenda'>Valor atual: {getValues('precoSP2_faixa_de_preco1')}</label>}
                                  </article>

                                  <article className='preco'>
                                    <label className='titulo'>PRECO DF 1 uni.</label>
                                    <input
                                        type='number'
                                        step={0.01}
                                        pattern="^\d*(\.\d{0,2})?$"
                                        {...register('precoDF_faixa_de_preco1')}
                                        />
                                    {getValues('precoDF_faixa_de_preco1') > 0 && <label className='legenda'>Valor atual: {getValues('precoDF_faixa_de_preco1')}</label>}
                                  </article>
                                  <article className='preco'>
                                    <label className='titulo'>PRECO DF1 1 uni.</label>
                                    <input
                                        type='number'
                                        step={0.01}
                                        pattern="^\d*(\.\d{0,2})?$"
                                        {...register('precoDF1_faixa_de_preco1')}
                                        />
                                    {getValues('precoDF1_faixa_de_preco1') > 0 && <label className='legenda'>Valor atual: {getValues('precoDF1_faixa_de_preco1')}</label>}
                                  </article>
                                  <article className='preco'>
                                    <label className='titulo'>PRECO GO 1 uni.</label>
                                    <input
                                        type='number'
                                        step={0.01}
                                        pattern="^\d*(\.\d{0,2})?$"
                                        {...register('precoGO_faixa_de_preco1')}
                                        />
                                    {getValues('precoGO_faixa_de_preco1') > 0 && <label className='legenda'>Valor atual: {getValues('precoGO_faixa_de_preco1')}</label>}
                                  </article>
                                  <article className='preco'>
                                    <label className='titulo'>PRECO RJ 1 uni.</label>
                                    <input
                                        type='number'
                                        step={0.01}
                                        pattern="^\d*(\.\d{0,2})?$"
                                        {...register('precoRJ_faixa_de_preco1')}
                                        />
                                    {getValues('precoRJ_faixa_de_preco1') > 0 && <label className='legenda'>Valor atual: {getValues('precoRJ_faixa_de_preco1')}</label>}
                                  </article>
                                  <article className='preco'>
                                    <label className='titulo'>PRECO RJ1 1 uni.</label>
                                    <input
                                        type='number'
                                        step={0.01}
                                        pattern="^\d*(\.\d{0,2})?$"
                                        {...register('precoRJ1_faixa_de_preco1')}
                                        />
                                    {getValues('precoRJ1_faixa_de_preco1') > 0 && <label className='legenda'>Valor atual: {getValues('precoRJ1_faixa_de_preco1')}</label>}
                                  </article>
                                  <article className='preco'>
                                    <label className='titulo'>PRECO X SUPER 1 uni.</label>
                                    <input
                                        type='number'
                                        step={0.01}
                                        pattern="^\d*(\.\d{0,2})?$"
                                        {...register('preco_x_super_faixa_de_preco1')}
                                        />
                                    {getValues('preco_x_super_faixa_de_preco1') > 0 && <label className='legenda'>Valor atual: {getValues('preco_x_super_faixa_de_preco1')}</label>}
                                  </article>
                            </article>
                        </div>
                        <div>
                        <article className='lista_precos'>
                                <article className='preco'>
                                    <label className='titulo'>PRECO SP 2 uni.</label>
                                    <input
                                        type='number'
                                        step={0.01}
                                        pattern="^\d*(\.\d{0,2})?$"
                                        {...register('precoSP_faixa_de_preco2')}
                                        />
                                    {getValues('precoSP_faixa_de_preco2') > 0 && <label className='legenda'>Valor atual: {getValues('precoSP_faixa_de_preco2')}</label>}
                                </article>
                                <article className='preco'>
                                    <label className='titulo'>PRECO SP1 2 uni.</label>
                                    <input
                                        type='number'
                                        step={0.01}
                                        pattern="^\d*(\.\d{0,2})?$"
                                        {...register('precoSP1_faixa_de_preco2')}
                                        />
                                    {getValues('precoSP1_faixa_de_preco2') > 0 && <label className='legenda'>Valor atual: {getValues('precoSP1_faixa_de_preco2')}</label>}
                                  </article>
                                  <article className='preco'>
                                    <label className='titulo'>PRECO SP2 2 uni.</label>
                                    <input
                                        type='number'
                                        step={0.01}
                                        pattern="^\d*(\.\d{0,2})?$"
                                        {...register('precoSP2_faixa_de_preco2')}
                                        />
                                    {getValues('precoSP2_faixa_de_preco2') > 0 && <label className='legenda'>Valor atual: {getValues('precoSP2_faixa_de_preco2')}</label>}
                                  </article>
                                  <article className='preco'>
                                    <label className='titulo'>PRECO DF 2 uni.</label>
                                    <input
                                        type='number'
                                        step={0.01}
                                        pattern="^\d*(\.\d{0,2})?$"
                                        {...register('precoDF_faixa_de_preco2')}
                                        />
                                    {getValues('precoDF_faixa_de_preco2') > 0 && <label className='legenda'>Valor atual: {getValues('precoDF_faixa_de_preco2')}</label>}
                                  </article>
                                  <article className='preco'>
                                    <label className='titulo'>PRECO DF1 2 uni.</label>
                                    <input
                                        type='number'
                                        step={0.01}
                                        pattern="^\d*(\.\d{0,2})?$"
                                        {...register('precoDF1_faixa_de_preco2')}
                                        />
                                    {getValues('precoDF1_faixa_de_preco2') > 0 && <label className='legenda'>Valor atual: {getValues('precoDF1_faixa_de_preco2')}</label>}
                                  </article>
                                  <article className='preco'>
                                    <label className='titulo'>PRECO GO 2 uni.</label>
                                    <input
                                        type='number'
                                        step={0.01}
                                        pattern="^\d*(\.\d{0,2})?$"
                                        {...register('precoGO_faixa_de_preco2')}
                                        />
                                    {getValues('precoGO_faixa_de_preco2') > 0 && <label className='legenda'>Valor atual: {getValues('precoGO_faixa_de_preco2')}</label>}
                                  </article>
                                  <article className='preco'>
                                    <label className='titulo'>PRECO RJ 2 uni.</label>
                                    <input
                                        type='number'
                                        step={0.01}
                                        pattern="^\d*(\.\d{0,2})?$"
                                            {...register('precoRJ_faixa_de_preco2')}
                                        />
                                    {getValues('precoRJ_faixa_de_preco2') > 0 && <label className='legenda'>Valor atual: {getValues('precoRJ_faixa_de_preco2')}</label>}
                                  </article>
                                  <article className='preco'>
                                    <label className='titulo'>PRECO RJ1 2 uni.</label>
                                    <input
                                        type='number'
                                        step={0.01}
                                        pattern="^\d*(\.\d{0,2})?$"
                                        {...register('precoRJ1_faixa_de_preco2')}
                                        />
                                    {getValues('precoRJ1_faixa_de_preco2') > 0 && <label className='legenda'>Valor atual: {getValues('precoRJ1_faixa_de_preco2')}</label>}
                                  </article>
                                  <article className='preco'>
                                    <label className='titulo'>PRECO X SUPER 2 uni.</label>
                                    <input
                                        type='number'
                                        step={0.01}
                                        pattern="^\d*(\.\d{0,2})?$"
                                        {...register('preco_x_super_faixa_de_preco2')}
                                        />
                                    {getValues('preco_x_super_faixa_de_preco2') > 0 && <label className='legenda'>Valor atual: {getValues('preco_x_super_faixa_de_preco2')}</label>}
                                  </article>
                                </article>
                        </div>
                        <div>
                            <article className='lista_precos'>
                                <article className='preco'>
                                    <label className='titulo'>PRECO SP 3 uni.</label>
                                    <input
                                        type='number'
                                        step={0.01}
                                        pattern="^\d*(\.\d{0,2})?$"
                                        {...register('precoSP_faixa_de_preco3')}
                                        />
                                    {getValues('precoSP_faixa_de_preco3') > 0 && <label className='legenda'>Valor atual: {getValues('precoSP_faixa_de_preco3')}</label>}
                                </article>
                                <article className='preco'>
                                    <label className='titulo'>PRECO SP1 3 uni.</label>
                                    <input
                                        type='number'
                                        step={0.01}
                                        pattern="^\d*(\.\d{0,2})?$"
                                        {...register('precoSP1_faixa_de_preco3')}
                                        />
                                    {getValues('precoSP1_faixa_de_preco3') > 0 && <label className='legenda'>Valor atual: {getValues('precoSP1_faixa_de_preco3')}</label>}
                                </article>
                                <article className='preco'>
                                    <label className='titulo'>PRECO SP2 3 uni.</label>
                                    <input
                                        type='number'
                                        step={0.01}
                                        pattern="^\d*(\.\d{0,2})?$"
                                        {...register('precoSP2_faixa_de_preco3')}
                                        />
                                    {getValues('precoSP2_faixa_de_preco3') > 0 && <label className='legenda'>Valor atual: {getValues('precoSP2_faixa_de_preco3')}</label>}
                                </article>
                                <article className='preco'>
                                    <label className='titulo'>PRECO DF 3 uni.</label>
                                    <input
                                        type='number'
                                        step={0.01}
                                        pattern="^\d*(\.\d{0,2})?$"
                                        {...register('precoDF_faixa_de_preco3')}
                                        />
                                    {getValues('precoDF_faixa_de_preco3') > 0 && <label className='legenda'>Valor atual: {getValues('precoDF_faixa_de_preco3')}</label>}
                                </article>
                                <article className='preco'>
                                    <label className='titulo'>PRECO DF1 3 uni.</label>
                                    <input
                                        type='number'
                                        step={0.01}
                                        pattern="^\d*(\.\d{0,2})?$"
                                            {...register('precoDF1_faixa_de_preco3')}
                                        />
                                    {getValues('precoDF1_faixa_de_preco3') > 0 && <label className='legenda'>Valor atual: {getValues('precoDF1_faixa_de_preco3')}</label>}
                                </article>
                                <article className='preco'>
                                    <label className='titulo'>PRECO GO 3 uni.</label>
                                    <input
                                        type='number'
                                        step={0.01}
                                        pattern="^\d*(\.\d{0,2})?$"
                                        {...register('precoGO_faixa_de_preco3')}
                                        />
                                    {getValues('precoGO_faixa_de_preco3') > 0 && <label className='legenda'>Valor atual: {getValues('precoGO_faixa_de_preco3')}</label>}
                                </article>
                                <article className='preco'>
                                    <label className='titulo'>PRECO RJ 3 uni.</label>
                                    <input
                                        type='number'
                                        step={0.01}
                                        pattern="^\d*(\.\d{0,2})?$"
                                        {...register('precoRJ_faixa_de_preco3')}
                                        />
                                    {getValues('precoRJ_faixa_de_preco3') > 0 && <label className='legenda'>Valor atual: {getValues('precoRJ_faixa_de_preco3')}</label>}
                                </article>
                                <article className='preco'>
                                    <label className='titulo'>PRECO RJ1 3 uni.</label>
                                    <input
                                        type='number'
                                        step={0.01}
                                        pattern="^\d*(\.\d{0,2})?$"
                                        {...register('precoRJ1_faixa_de_preco3')}
                                        />
                                    {getValues('precoRJ1_faixa_de_preco3') > 0 && <label className='legenda'>Valor atual: {getValues('precoRJ1_faixa_de_preco3')}</label>}
                                </article>
                                <article className='preco'>
                                    <label className='titulo'>PRECO X SUPER 3 uni.</label>
                                    <input
                                        type='number'
                                        step={0.01}
                                        pattern="^\d*(\.\d{0,2})?$"
                                        {...register('preco_x_super_faixa_de_preco3')}
                                        />
                                    {getValues('preco_x_super_faixa_de_preco3') > 0 && <label className='legenda'>Valor atual: {getValues('preco_x_super_faixa_de_preco3')}</label>}
                                </article>
                            </article>
                        </div>
                    </div>

                    <SaveButton
                        onClick={handleSubmit(atualizarPrecos)}
                        type='button'
                        >SALVAR</SaveButton>
                </Container>
            </article>
        </div>
    )
}